<div>
    <button style="margin: 15px" class="floatR marginB" nz-button nzType="primary" nzShape="circle"
        (click)="addCustomField()">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
    </button>
    <h1>Pin Management</h1>

    <div>Custom Fields:</div>
    <nz-table [nzData]="customFields" [nzLoading]="loading" nzSize="small" style="margin-top: 12px;">
        <thead>
            <tr>
                <th>Label Name</th>
                <th>Type</th>
                <th>Visible</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let field of customFields">
                <td>{{ field.custom_field?.name }}</td>
                <td>{{ field.custom_field?.type | titlecase }}</td>
                <td>
                    <nz-switch [ngModel]="field.status === 'visible'" (ngModelChange)="toggle(field)">
                    </nz-switch>
                </td>
            </tr>
        </tbody>
    </nz-table>

    <nz-modal [nzVisible]="showModal" nzTitle="Add Custom Field" [nzWidth]="480" (nzOnCancel)="showModal = false"
        [nzFooter]="editModalFooter">
        <ng-container *nzModalContent>
            <form nz-form>
                <nz-form-item>
                    <nz-form-label>Label Name</nz-form-label>
                    <nz-form-control>
                        <input nz-input [(ngModel)]="fieldName" name="fieldName" placeholder="Name" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>Type</nz-form-label>
                    <nz-form-control>
                        <nz-select [(ngModel)]="fieldType" name="fieldType" style="width: 200px;">
                            <nz-option nzValue="input" nzLabel="Input"></nz-option>
                            <nz-option nzValue="date" nzLabel="Date Picker"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </form>
        </ng-container>
        <ng-template #editModalFooter>
            <button nz-button nzType="default" (click)="showModal = false">Cancel</button>
            <button nz-button nzType="primary" (click)="saveField()">Save</button>
        </ng-template>
    </nz-modal>
</div>